module.exports = __webpack_public_path__ + "img/Avatar-69.aa3c9385.svg";